/** Утилита для работы с датами */
export default class UtilDate {

    /**
     * Получить из списка дат ближайщую к текущему системному времени
     * @static
     * @public
     * @param {Array} dates - список дат
     * @returns {Array}
     */
    static getNearDate(dates = []) {
        const datesBuff = [...dates];

        const dateNow = new Date();
        const dateNowString = this.toString(dateNow.getFullYear(), dateNow.getMonth() + 1);
        const timestampNow = Date.parse(dateNowString);

        datesBuff.sort((dateFirst, dateSecond) => {
            const timestampDiffFirst = Math.abs(timestampNow - Date.parse(dateFirst));
            const timestampDiffSecond = Math.abs(timestampNow - Date.parse(dateSecond));
            return timestampDiffFirst - timestampDiffSecond;
        });

        return datesBuff[0] ? [datesBuff[0]] : [];
    }
}
